import ViewPadrao from "../views/ViewPadrao";
import ClienteList from "../views/ClienteList";
import ClienteCad from "../views/ClienteCad";

export default {
  path: "cliente",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "cliente-list",
      component: ClienteList,
    },
    {
      path: "novo",
      name: "cliente-formulario",
      component: ClienteCad,
    },
    {
      path: "editar/:id",
      name: "cliente-formulario-editar",
      component: ClienteCad,
    },
  ],
};
